import {
  EConcurrencyType,
  EGeoType,
  IGetBetsPositionRequest,
} from '../../../../repositories/auction/v1/get-bets-position';
import { ECategory } from '../../../../repositories/billing-tariffs/entities/PublishTerms/GetPublishTermsRequest';
import { ICoordinates, IGeoAddressItem, IOfferState } from '../../../../types/reducers/offer';
import { EPlacingType, EServiceId } from '../../../../types/reducers/publishTerms';
import { getIsCommercial } from '../../../../utils/category/getIsCommercial';
import { getMultiListingSlotsCount } from '../../../../utils/commercialMultiAds/getMultiListingSlotsCount';
import { getBetPositionServices } from './getBetPositionServices';
import { IPackage } from '../../../../reducers/v2/publicationPackages/types';

interface IGetBetPositionParams {
  serviceIds: EServiceId[];
  packages: IPackage[];
  offer: IOfferState;
  childLocation: IGeoAddressItem | null;
  coordinates: ICoordinates;
  currentBet: number;
  isAuctionEnabled: boolean;
  isPromotionPackageSelected: boolean;
  extraData: object;
  activePlacingType: EPlacingType | null;
  diffPricesPackageEnabled: boolean;
}

export function getBetPositionParams(params: IGetBetPositionParams): IGetBetsPositionRequest {
  const {
    serviceIds,
    packages,
    offer: { category, id, bargainTerms, totalArea, areaParts },
    childLocation,
    coordinates: { lat, lng },
    currentBet,
    isAuctionEnabled,
    isPromotionPackageSelected,
    extraData,
    activePlacingType,
    /**
     * @todo Удалить строку с RS
     * @description Данный функционал появился в задаче CD-166175, будет удалён в задаче CD-166972
     */
    diffPricesPackageEnabled,
  } = params;

  const geoId = childLocation?.id || undefined;
  const geoType = (childLocation?.type as unknown as EGeoType) || undefined;

  const packageIds = packages.map(item => item.serviceId);

  const services = getBetPositionServices({
    serviceIds,
    packageIds,
    currentBet,
    isAuctionEnabled,
    isPromotionPackageSelected,
  });

  const parameters = {
    concurrencyType: EConcurrencyType.Local,
    announcementId: id,
    price: bargainTerms.price,
    geoId,
    geoType,
    category: category as ECategory,
    services,
    lat,
    lon: lng,
    extraData,
  };

  const isCommercial = getIsCommercial(category);
  const isPackageOnUi = activePlacingType ? activePlacingType === EPlacingType.package : null;

  if (isCommercial) {
    Object.assign(parameters, {
      price: bargainTerms.price,
      currency: bargainTerms.currency,
      priceType: bargainTerms.priceType,
      paymentPeriod: bargainTerms.paymentPeriod,
      totalArea,
      multiListingSlotsCount: getMultiListingSlotsCount(areaParts),
      /**
       * @todo Удалить строку с RS
       * @description Данный функционал появился в задаче CD-166175, будет удалён в задаче CD-166972
       *  */
      ...(diffPricesPackageEnabled && { isPackageOnUi }),
    });
  }

  return parameters;
}
